import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getFuelStations(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_GUNS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUNS,
    options
  )
}

function _getFuelStation(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_GUNS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUN,
    options
  )
}

function _getFuelStationPreview(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_GUNS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUN_PREVIEW,
    options
  )
}
function _getFuelStationPopup(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_GUNS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUN_POPUP,
    options
  )
}

function _postFuelStation(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_GUNS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].POST_FUEL_STATION_GUN,
    options
  )
}

function _putFuelStation(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_GUNS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].PUT_FUEL_STATION_GUN,
    options
  )
}

function _patchFuelStation(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_GUNS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].PATCH_FUEL_STATION_GUN,
    options
  )
}

function _deleteFuelStation(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_GUNS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].DELETE_FUEL_STATION_GUN,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUNS]: _getFuelStations,
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUN]: _getFuelStation,
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUN_PREVIEW]: _getFuelStationPreview,
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUN_POPUP]: _getFuelStationPopup,
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].POST_FUEL_STATION_GUN]: _postFuelStation,
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].PUT_FUEL_STATION_GUN]: _putFuelStation,
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].PATCH_FUEL_STATION_GUN]: _patchFuelStation,
  [ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].DELETE_FUEL_STATION_GUN]: _deleteFuelStation

}